<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card class="box" v-if="ay_std_div_list != null">
      <v-toolbar class="toolbar" flat dense>
        <v-toolbar-title>
          <strong> Student Registration Information </strong>
        </v-toolbar-title>
      </v-toolbar>
      <v-row justify="center" dense>
        <v-col sm="2">
          <v-icon color="error">*</v-icon>
          <v-autocomplete color="#0F2027" dense rounded required v-model="sel_ay_data" return-object
            :items="ay_std_div_list" item-text="ay" label="Select Academic Year" outlined @change="getStd()"
            @click="putnull" persistent-hint hint="Please Select Academic Year" />
        </v-col>
        <v-col sm="2" v-if="std_div_list != null">
          <v-icon color="error">*</v-icon>
          <v-autocomplete color="#0F2027" dense rounded required v-model="sel_std_data" return-object
            :items="std_div_list" item-text="std" label="Select Standard" outlined @change="getDiv" @click="putnull"
            persistent-hint hint="Please Select Standard" />
        </v-col>
        <v-col sm="2" v-if="div_list != null">
          <v-icon color="error">*</v-icon>
          <v-autocomplete color="#0F2027" dense rounded required v-model="div" return-object :items="div_list"
            item-text="div_name" label="Select Division" outlined @click="putnull" persistent-hint
            hint="Please Select Division" />
        </v-col>

        <v-col sm="2" v-if="sel_ay_data && sel_std_data && div">
          <v-btn class="mt-6 button" @click="getlearners()" :loading="fetch_loader">Fetch</v-btn>
        </v-col>
      </v-row>

      <v-toolbar flat dense v-if="stud_reg_info.length > 0">
        <!-- <download-excel
          v-if="bookList1.length > 0"
          class="mr-2 pb-3 pt-2"
          :data="bookList1"
          :fields="table_fields"
          worksheet="Student_List"
          name="Student_Registration_List.xls"
        >
          <v-btn color="success" outlined rounded>
            <v-icon dark>mdi-file-excel</v-icon> Export
          </v-btn>
        </download-excel> -->
        <v-btn rounded class="ma-2 mr-2 pb-3 pt-2" v-if="bookList1.length > 0" color="success" outlined
          @click="fnExcelReport('my-table-id', 'StudentRegistrationInfo')" :loading="loader"><v-icon
            color="success">mdi-export</v-icon>Export</v-btn>
      </v-toolbar>
      <div id="my-table-id">
        <v-data-table v-if="bookList1.length > 0" dense :headers="headers1" :items="bookList1" :search="search"
          class="elevation-1 mytable" @current-items="getFiltered">
          <template v-slot:top class="pb-5">
            <v-row justify="center" align="center">
              <tr class="t-row">
                <div>
                  <th>
                    <v-row>
                      <span v-for="header in headers1" :key="header.text">
                        <span v-if="filters.hasOwnProperty(header.value)">
                          <v-autocomplete class="mr-2 pb-5 pt-2" flat hide-details small rounded dense outlined
                            color="#0F2027" :label="header.text" multiple clearable
                            :items="columnValueList(header.value)" v-model="filters[header.value]"></v-autocomplete>
                        </span>
                      </span>
                    </v-row>
                  </th>
                </div>
              </tr>
            </v-row>
          </template>
        </v-data-table>
      </div>
    </v-card>
  </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },

  data() {
    return {
      table_fields: {
        "Sr. No": "sr_no",
        "Student Name": "name",
        "PRN No": "Reg_No",
        Division: "div",
        Standard: "std",
        "Subject Code": "course_code",
        "Subject Name": "course_name",
        "Subject Type": "course_type",
      },
      fetch_loader: false,
      extraBreadcrumbItems: [


      ],
      breadcrumbClass: "breadcrumb-style1",
      com_sub_loader: false,
      overlay: false,
      selected: [],
      snackbar: false,
      pagination: {
        sortBy: "name",
      },
      dialog: false,
      dialog1: false,
      course_list: [],
      crs_id: null,
      search: "",
      dialog_delete_que: false,
      deleteItem: {
        delete_id: "",
      },
      crs_list: [],
      snackbar_msg: "",
      color: "",
      snackbar: false,
      singleSelect: false,
      selectedTasks: [],
      ay_std_div_list: null,
      sel_ay_data: null,
      show_tt: false,
      std_div_list: null,
      sel_std_data: null,
      div_list: null,
      div: null,
      overlay: false,
      inst_list: null,
      learner: [],
      filterArr: [],
      stud_reg_info: [],
      filters: {
        std: [],
        div: [],
        registration_number: [],
        learner_list: [],
        course_type: [],
        course_name: [],
      },
      headers1: [
        {
          text: "Sr. No.",
          sortable: false,
          value: "sr_no",
        },
        {
          text: "Student Name",
          align: "center",
          sortable: false,
          value: "name",
        },
        {
          text: "PRN NO",
          align: "center",
          sortable: false,
          value: "Reg_No",
        },
        {
          text: "Roll No",
          align: "center",
          sortable: false,
          value: "roll_no",
        },
        {
          text: "Subject Code",
          align: "center",
          sortable: false,
          value: "course_code",
        },
        {
          text: "Subject Name",
          align: "center",
          sortable: false,
          value: "course_name",
        },
        {
          text: "Subject Type",
          align: "center",
          sortable: false,
          value: "course_type",
        },
        {
          text: "Standard",
          align: "center",
          sortable: false,
          value: "std",
        },
        {
          text: "Division",
          align: "center",
          sortable: false,
          value: "div",
        },
      ],
    };
  },
  computed: {
    bookList1() {
      return this.stud_reg_info.filter((d) => {
        return Object.keys(this.filters).every((f) => {
          return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
        });
      });
    },
  },
  methods: {
    fnExcelReport(id, name) {
  let tab_text = `<table border='1px'>
    <tr>
      <th>SR. No.</th>
      <th>Student Name</th>
      <th>PRN NO</th>
      <th>Subject Code</th>
      <th>Subject Name</th>
      <th>Subject Type</th>
      <th>Standard</th>
      <th>Division</th>
      
    </tr>`;

  this.bookList1.forEach((item, index) => {
    tab_text += `
    <tr>
        <td>${index + 1}</td>
        <td>${item.name || ''}</td>
        <td>${item.Reg_No || ''}</td>
        <td>${item.course_code || ''}</td>
        <td>${item.course_name || ''}</td>
        <td>${item.course_type || ''}</td>
        <td>${item.std || ''}</td>
        <td>${item.div || ''}</td>
      </tr>`;
  });

  tab_text += '</table>';

  const blob = new Blob([tab_text], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  });
  const filename = name + '_' + parseInt(Math.random() * 10000000000) + '.xls';

  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    // For IE
    window.navigator.msSaveOrOpenBlob(blob, filename);
  } else {
    // For modern browsers
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    window.URL.revokeObjectURL(url);
  }
},
    getFiltered(e) {
      this.filterArr = e;
    },
    columnValueList(val) {
      return this.stud_reg_info.map((d) => d[val]);
    },
    columnValueList1(val) {
      return this.learner_list.map((d) => d[val]);
    },
    getStd() {
      this.std_div_list = null;
      this.sel_std_data = null;
      this.div_list = null;
      this.div = null;
      this.std_div_list = this.sel_ay_data.std_list;
    },
    getDiv() {
      this.div_list = ["All"];
      this.div = "All";
      this.div_list = this.sel_std_data.div_list;
      this.div_list.unshift("All");
      this.div = this.div_list[0];
      if (this.div_list.length == 0) {
        alert("No division found!!!");
        this.div_list = null;
      }
    },
    putnull() {
      this.learner = [];
    },
    getlearners() {
      this.fetch_loader = true;
      let div = this.div.div_id;
      if (this.div.div_id) {
        div = this.div.div_id;
      } else {
        div = this.div;
      }
      const formData = {
        ay: this.sel_ay_data.ay_id,
        standard: this.sel_std_data.std_id,
        division: div,
      };
      //   alert(
      //     " this is standard" +
      //       JSON.stringify(formData.standard) +
      //       "Academic Year- " +
      //       JSON.stringify(formData.ay) +
      //       "this is division-" +
      //       JSON.stringify(formData.division)
      //   );
      axios
        .post("/Examination/getStudentRegistrationinfo", formData)
        .then((res) => {
          this.stud_reg_info = res.data.stud_reg_info;
          this.fetch_loader = false;
          // alert(JSON.stringify(this.stud_reg_info));
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          this.fetch_loader = false;
        })
        .finally(() => {
          ay = null;
          this.fetch_loader = false;
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    onload() {
      axios
        .post("/commonAPI/get_ay_std_div")
        .then((res) => {
          this.ay_std_div_list = res.data.data;
          this.sel_ay_data = res.data.curr_ay;
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        })
        .finally(() => {});
    },
    getcourse(subject_id) {
      const data = {
        subject_id: subject_id,
      };
      axios
        .post("/Examination/getcourse", data)
        .then((res) => {
          this.crs_list = res.data.crs_list;

          this.dialog = true;
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        })
        .finally(() => {});
    },
  },
  mounted() {
    this.onload();
  },
};
</script>
<style scoped>
.radiospace {
  margin: 1rem !important;
  padding: 0%;
}
.btn-css {
  outline: 0 !important;
  outline-offset: 0 !important;
  background-image: none !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
  background-color: #fff !important;
  text-decoration: underline;
  color: #0f2027 !important;
  text-align: left;
}

.btn-css:hover {
  outline: 0 !important;
  outline-offset: 0 !important;
  background-image: none !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
  background-color: #ffff !important;
  color: #0f2027 !important;
  text-decoration: underline;
  text-align: left;
}
.t-row {
  padding: 1rem i !important;
}

.delete-avatar {
  transition: 0.3s;
  border: 1px solid red;
  margin: 0.2rem !important;
}
.delete-avatar:hover {
  background-color: transparent;
}
.delete-v-icon {
  padding-left: 8px;
  padding-top: 1px;
  font-size: 15px;
}
.delete-v-icon:hover {
  color: white;
}
.v-dialogss {
  bottom: 880;
  right: 0;
}
</style>
